<template>
	<div class="w-100">
    <div :id="data.id" class="position-relative" style="top: -190px"></div>
    <img :src="data.image_url" class="w-100 rounded-3 object-fit box-shadow-primary" height="160">
    <p class="mb-0 body-2-2 text-truncate text-16 font-bold mt-2">{{data.name}}</p>
    <p class="mb-0 body-2-2-1 text-truncate">{{data.description}}</p>
    <p v-if="is_decrease_promo" class="mb-0 ls-0-1 text-14 text-light-menu text-line-through d-inline-block">{{formatCurrency(promotion_price)}}</p>
    <p class="mb-0 body-2 text-truncate font-bold text-14 text-orange">{{formatCurrency(final_price)}}</p>
  </div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'

	export default{
		props: ['data'],
		computed:{
			is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? this.base_price.price_sell_base : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
		},
		methods:{
			formatCurrency(value){
        return formatCurrency(value);
      },
      openDetail(){
      	this.$emit('detail', this.data)
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/member/ProductList.vue